<template lang="html">
  <div class="container-fluid _verification_page">
    <div class="col-sm p-0">
      <div class="row m-0 afterverify_page align-items-center justify-content-center">
        <div class="text-center">
          <img src="@/assets/image/icon/fireworks.svg" alt="">
          <h5>
            Congratulation!<br>
            Your account Has Been Successfully Verified!
            Please Re-Login to Fully Access Andalin’s Platform
          </h5>
          <div class="text-center mt-4">
            <router-link to="/">
              <button type="button" class="_global__button--redcorporite pl-4 pr-4">
                Click Here to Re-Login
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/view/verifyReLogin/index.vue